import { logDebug } from './logger';

export const perfStart = (name) => {
  if (typeof performance !== 'undefined') {
    performance.mark(`${name}:start`);
  }
};

export const perfEnd = (name) => {
  if (typeof performance === 'undefined') {
    return;
  }

  const start = `${name}:start`;
  const end = `${name}:end`;
  performance.mark(end);
  performance.measure(name, start, end);

  const measures = performance.getEntriesByName(name, 'measure');
  const latest = measures[measures.length - 1];
  if (latest) {
    logDebug(`[Perf] ${name}: ${latest.duration.toFixed(2)}ms`);
  }

  performance.clearMarks(start);
  performance.clearMarks(end);
  performance.clearMeasures(name);
};

